import { AutopilotSidebar as BaseAutopilotSidebar } from '../AutopilotSidebar/AutopilotSidebar'
import { useIsAddMoreImagesView } from './BrandKitConfirmContext'

const ADD_MORE_IMAGES_SECTIONS = [
  {
    heading: 'Your brand images',
    text: "We've generated images and found stock options that match your brand. Choose your favorites.",
  },
]

const BRAND_KIT_CONFIRM_SECTIONS = [
  {
    heading: 'Customize your photos',
    text: "Hit the edit button in the image section to add photos or remove any that don't feel right. Need help perfecting your Brand Kit? Book a quick 1:1 call with our team.",
  },
]

export const AutopilotSidebar = () => {
  const isAddMoreImages = useIsAddMoreImagesView()

  return <BaseAutopilotSidebar sections={isAddMoreImages ? ADD_MORE_IMAGES_SECTIONS : BRAND_KIT_CONFIRM_SECTIONS} />
}
